import { BaseAPI } from "@utils/base-api";
import {
  ApplyDiscountToCustomerResponse,
  GetLandingPageDiscountCodesQuery,
  GetLandingPageDiscountCodesResponse,
  IDiscountApplicationCustomerInfo,
  ValidateDiscountCodeRequest,
} from "@discounts/types";
import { AxiosRequestConfig, AxiosResponse } from "axios";

import { IFreshSubDiscountCalculations } from "@/discount-calculation";
import { DiscountCode } from "@/primary-models";

export interface IUpcomingDiscount {
  name: string;
  expiresAt: string;
}

export class DiscountsAPI extends BaseAPI {

  public async getQueuedDiscounts(): Promise<AxiosResponse<IDiscountApplicationCustomerInfo[]>> {
    return this.axios.get(
      "/applications/customer?filter=POTENTIALLY USABLE",
    );
  }

  public async getAllDiscountApplications(): Promise<AxiosResponse<IDiscountApplicationCustomerInfo[]>> {
    return this.axios.get(
      "/applications/customer",
    );
  }

  public async getDiscountCalculations(subscriptionId: number, discountCode: string):
  Promise<AxiosResponse<IFreshSubDiscountCalculations>> {
    return this.axios.get(
      `/estimation/subscription?subscriptionId=${subscriptionId}&code=${discountCode}`,
    );
  }

  public async applyDiscount(discountCode: string):
  Promise<AxiosResponse<ApplyDiscountToCustomerResponse>> {
    return this.axios.post("/applications/customer", { code: discountCode });
  }

  public async validateInfluencerCode(discountCode: string):
  Promise<AxiosResponse<{ success: boolean, updatedDiscount: DiscountCode }>> {
    return this.axios.put("/codes/validate-influencer", { code: discountCode });
  }

  public async validateDiscountCode(
    discountCode: string,
    options: Omit<ValidateDiscountCodeRequest, "code"> | undefined = undefined,
    config: AxiosRequestConfig | undefined = undefined,
  ):
  Promise<AxiosResponse<{ success: boolean, discount: DiscountCode }>> {
    return this.axios.post("/codes/validate-discount-code", { code: discountCode, ...options }, config);
  }

  /** Lists every code a discount landing page pretty URL may resolve to, so a caller can
   * hold the list rather than validating one code per request. Needs the client to have been
   * built with WEBSITE_INTERNAL_API_KEY as its access token. */
  public async getLandingPageDiscountCodes(
    query: GetLandingPageDiscountCodesQuery | undefined = undefined,
    config: AxiosRequestConfig | undefined = undefined,
  ): Promise<AxiosResponse<GetLandingPageDiscountCodesResponse>> {
    return this.axios.get("/codes/landing-page-codes", { params: query, ...config });
  }

}
